<template>
  <div class="main flex_column">

    <IifeUser :swiperList="advertSwiper" />

    <div class="life-menu">
      <div v-if="loading" class="loading-container">
        <div class="loading-text">正在加载生活缴费分类...</div>
      </div>
      <Menu v-else :list="menuList" @click="menuClick" :authToken="authToken" />
    </div>

    <div class="life-advert">
      <MySwiper :swipers="swipers" radius="9px" />
    </div>

    <LifeNavBar :authToken="authToken" />

    <!-- <div class="">
      <myswiper :swipers="swipers"></myswiper>
    </div> -->

    <!-- <grid></grid> -->

    <!-- <el-container>
      <paymentlist></paymentlist>

      <el-main>
        <notice></notice>
      </el-main>

      <el-footer>
        Developed by 龍科技
      </el-footer>
    </el-container> -->
  </div>
</template>
<script>
  import MySwiper from '@/components/swiper.vue';
  // import paymentlist from '@/components/paymentlist.vue';
  import grid from '@/components/grid.vue';
  import notice from '@/components/notice.vue';
  import IifeUser from '@/components/lifeUser.vue';
  import Menu from '@/components/menu.vue';
  import LifeNavBar from '@/components/lifeNavBar.vue';

  export default {
    name: 'lifepay',
    // 组件注册
    components: {
      // paymentlist,
      MySwiper,
      grid,
      notice,
      IifeUser,
      Menu,
      LifeNavBar
    },
    data() {
      return {
        swipers: [],
        rechargeCategoryData: [],
        loading: false,
        advertSwiper: []
      }
    },
    computed: {
      authToken() {
        return localStorage.getItem('auth_token')
      },
      menuList() {
        return this.rechargeCategoryData
      }
    },
    created() {
      this.getLifeBanner()
      this.getMenuCategories()
    },
    methods: {
      // 获取生活缴费菜单分类（固定 esim/水费/电费/网费/高速费）
      async getMenuCategories() {
        try {
          this.loading = true
          const { data } = await this.$api.request('System/getProducts', {
            position: 1,
            client: 'h5',
            cids: '[89,115,116,117,118]'
          })
          // menu.vue 布局：list[4] 显示在左侧大块，list[0-3] 显示在右侧格
          // 确保 eSIM(89) 固定在 index 4（左侧）
          const list = Array.isArray(data) ? [...data] : []
          const esimIdx = list.findIndex(item => item.id === 89)
          if (esimIdx !== -1) {
            list.push(list.splice(esimIdx, 1)[0])
          }
          this.rechargeCategoryData = list
        } catch (error) {
          console.error('获取生活缴费分类失败:', error)
          this.$message({
            message: '获取生活缴费分类失败，请检查网络！',
            type: 'warning'
          })
        } finally {
          this.loading = false
        }
      },
      // 获取生活缴费banner
      async getLifeBanner() {
        const { data } = await this.$api.request('System/banners', {
           position: 1,
           location: ''
        })
        this.advertSwiper = data[0]
        this.swipers = data[1]
      },
      menuClick(item) {
        // console.log(item)
        this.$store.commit('setIsLife', 1)
        this.$router.push({
          path: '/placeOrder',
          query: { id: item.id }
        })
      }
    }
  }
</script>
<style scoped>
  .el-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
  }

  .life-menu {
    margin-top: 11px;
    /* padding: 0 24px; */
    padding: 0 16px;
  }

  .life-advert {
    padding: 0 24px;
    margin-top: 35px;
    margin-bottom: 80px;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
  }

  .loading-text {
    color: #999;
    font-size: 14px;
  }
</style>
<style>
  .life-advert .swiper-container {
    padding-bottom: 13px;
  }
  .swiper-pagination-fraction, .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0 !important;
  }
  .swiper-pagination {
    text-align: right !important;
  }
  .swiper-pagination-bullet-active {
    background: #FF0000 !important;
  }
  .swiper-pagination-bullet {
    width: 7px;
    height: 7px;
    background: #C4C4C4;
  }
</style>



// WEBPACK FOOTER //
// src/page/lifepay.vue